import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1516937941344-00b4e0337589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjaGVtaWNhbCUyMGluZHVzdHJ5fGVufDB8fHx8MTc1NzkwNTIyMnww&ixlib=rb-4.1.0&q=85"
          alt="Industrial Chemical Facility"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-800/80 to-teal-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            {/* Headline */}
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-teal-600/20 border border-teal-500/30 backdrop-blur-sm">
                <span className="text-teal-300 text-sm font-medium">ERP Solutions for Industry Leaders</span>
              </div>
              
              <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
                <span className="text-white">Empower.</span>{' '}
                <span className="text-teal-400">Integrate.</span>{' '}
                <span className="text-white">Elevate.</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-gray-300 max-w-2xl leading-relaxed">
                Your all-in-one ERP solution tailored for the Pharmaceutical, Analytical, Chemical, and Chemistry industries.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a 
                href="#demo"
                className="inline-flex items-center justify-center h-14 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 text-lg font-semibold rounded-md group transition-all duration-300 transform hover:scale-105"
              >
                See GENRA ERP in Action
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
              
              <a 
                href="https://www.youtube.com/watch?v=UpasLDan0_s" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center h-14 rounded-md border-2 border-white bg-transparent text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg font-semibold backdrop-blur-sm transition-all duration-300 transform hover:scale-105"
              >
                <Play className="mr-2 h-5 w-5" />
                Watch Demo
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 pt-8 border-t border-gray-700">
              <p className="text-gray-400 text-sm mb-4">Trusted by industry leaders</p>
              <div className="flex items-center space-x-8">
                <div className="text-white font-semibold">Pharmaceutical</div>
                <div className="text-white font-semibold">Chemical</div>
                <div className="text-white font-semibold">Analytical</div>
                <div className="text-white font-semibold">Chemistry Services</div>
              </div>
            </div>
          </div>

          {/* Right side - Optional stats or additional content */}
          <div className="hidden lg:flex flex-col space-y-8">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-teal-400 mb-2">99.9%</div>
              <div className="text-white font-medium">Uptime Guarantee</div>
              <div className="text-gray-300 text-sm mt-2">Enterprise-grade reliability</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-teal-400 mb-2">21 CFR</div>
              <div className="text-white font-medium">Part 11 Compliant</div>
              <div className="text-gray-300 text-sm mt-2">FDA regulation ready</div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-teal-400 mb-2">100+</div>
              <div className="text-white font-medium">Users Scalable</div>
              <div className="text-gray-300 text-sm mt-2">From 10 to enterprise scale</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};